class SizeGuideDropdown extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      label: '[size-guide-cta]',
      dropdown: '[size-guide-info]'
    }
    this.init();
  }

  init() {
    this.sizeLabels = document.querySelectorAll(this.selectors.label);
    this.sizeLabels?.forEach((label, index) => {
      label?.addEventListener('click', () => {
        const dropdown = this;
        if (dropdown) {
          dropdown.scrollIntoView();
          const collapseButton = dropdown.querySelector('.collapse-button');
          if (collapseButton && !collapseButton.classList.contains('active')) {
            collapseButton.click();
          }
        }
      });
    });
  }
}

customElements.define('size-guide-drop', SizeGuideDropdown);
